import { Component, ViewChild, ElementRef, Input } from "@angular/core";
import { interval, Subscription } from 'rxjs';

import { Debounce } from "lodash-decorators";
import * as _ from 'lodash';
import { ToastrService } from "ngx-toastr";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";

import { TrainingService } from "./services/training.service";
import { TrainingProvider } from "./models/trainingProvider";
import { WioaProgram } from "./models/wioaProgram";



@Component({
  selector: 'training-list',
  templateUrl: './training-list.component.html',
  styleUrls: ['./training-list.component.css'],
  providers: [TrainingService]
})
export class TrainingListComponent {

  @Input()
  tabs: boolean = false;

  @Input()
  selected: string = "wioa";

 
  trainingWioaCount: number = 0;
  trainingOtherCount: number = 0;
  timeout: boolean = false;
  subscription: Subscription;

  constructor(private trainingService: TrainingService) { }

  ngOnInit() {
    this.trainingBookmarkCounts();
  }

  setSelected(option: string) {
    this.selected = option;
  }

  trainingBookmarkCounts() {
    this.trainingService.getWioaPrograms().subscribe(res => {
      this.trainingWioaCount = res.length;
    })
    this.trainingService.getTraingProviders().subscribe(res => {
      this.trainingOtherCount = res.length;
    })
  }
  ngAfterViewInit() {
    const source = interval(30000)
    this.subscription = source.subscribe(val => this.trainingBookmarkCounts());

    this.resetTimeout();
  }

  resetTimeout() {
    this.timeout = false;

    setTimeout(() => {
      this.timeout = true;
    }, 30000);
  }
}
